<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 card-body">
        <h4 style="text-align: center;">{{ role.title }}</h4>
        <hr class="horizontal dark" />
        <div class="card h-100">
          <!--<details>-->
          <!--<summary>-->
          <div class="card-header px-3 py-2 bg-gradient-warning">
            <h6 class="mb-0 text-capitalize text-white">تعیین افراد عضو نقش</h6>
          </div>
          <!--</summary>-->
          <div class="card-body pt-2 px-2">
            <!--<ul class="list-group list-group-flush flex-flow-row">-->
            <ul class=" row Col-lg-12 col-md-12 col-sm-12 col-xs-12 px-2">
              <li class="list-group-item px-1 mx-1 mb-2">
                <div class="col-md-6">
                  <label class="form-control-label" for="companyTitle">جستجو کاربر بر اساس: نام - نام خانوادگی - سمت</label>
                  <vue-select v-model="user" :options="listUsers" dir="rtl" label="searchProp">
                    <template #no-options="{ search, searching, loading }">
                      موردی یافت نشد!
                    </template>
                  </vue-select>
                </div>
              </li>
              <template v-for="item in listCurrentMembers">
                <li class="list-group-item col-lg-4 col-md-4 col-sm-6 col-xs-12 px-2"
                    v-if="item.deleted == false">
                  <div class="row align-items-center">
                    <div class="col-auto d-flex align-items-center">
                      <a href="javascript:;" class="avatar">
                        <img class="border-radius-lg" alt="Image placeholder"
                             src="../../assets/img/team-1.png">
                      </a>
                    </div>
                    <div class="col ml-2">
                      <h6 class="mb-0">
                        {{item.firstName}} {{item.lastName}}
                      </h6>
                      <span v-if="item.isActive != undefined" class="badge badge-sm"
                            :class="{'badge-success' : item.isActive,  'badge-danger' : !item.isActive }">{{ item.isActive ? 'فعال' : 'غیرفعال' }}</span>
                    </div>
                    <div class="col-auto">
                      <button type="button"
                              @click="removeMember(item)"
                              class="btn btn-danger btn-xs mb-0">
                        حذف
                      </button>
                    </div>
                  </div>
                </li>
              </template>
            </ul>
            <hr class="horizontal dark" />
            <button type="button" class="btn bg-gradient-success mb-0" @click="submit()">ثبت تغییرات</button>
            <button class="btn bg-gray-400 me-3 float-start mb-0" type="button" @click="goBack">بازگشت</button>
          </div>
          <!--</details>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RoleService from "@/services/User/Role-service";
  import UserService from "@/services/User/User-service.js";

  export default {
    data() {
      return {
        id: null,
        listUsers: [],
        listCurrentMembers: [],
        selectedListPerson: [],
        //searchList: [],
        user: null,
        role: {}
      }
    },
    watch: {
      user(user) {
        if (user !== null) {
          this.addUser(user);
        }
      },
      role(role){
        this.getUsersByCompany(role.companyId);
      }
    },
    methods: {
      getCurrentMember() {
        RoleService.getUsersByRole(this.id).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.listCurrentMembers = result.data.map((user) => ({ ...user, deleted: false, isNew: false }));
            //setTimeout(() => console.log(this.listCurrentMembers), 100);
          }
        }).catch(e => {
          console.log(e);
        });
      },
      removeMember(item) {
        if (item.isNew == true) {
          const index = this.listCurrentMembers.map(v => v.personId).indexOf(item.personId);

          if (index > -1) {
            this.listCurrentMembers.splice(index, 1);
          }
        }
        else {
          item.deleted = true;
        }
      },
      submit() {
        //console.log(this.listCurrentMembers);
        let model = this.listCurrentMembers.filter((user) => !user.deleted).map(v => {
          return {
            RoleId: this.id,
            UserId: v.userId
          };
        });
        //console.log(model);
        RoleService.modifyUserRoles(model, this.id).then(response => {
          let result = response.data;

          if (!result.success) {
            this.submitButtonStatus = true;
            this.$toast.error(result.message);
          }
          else {
            this.$toast.success(result.message);
            this.$router.push('/roles/' + this.role.companyId);
          }
        }).catch(e => {
          console.log(e);
          this.submitButtonStatus = true;
        });
      },
      addUser(user) {
        const index = this.listCurrentMembers.map(v => v.userId).indexOf(user.userId);

        if (index == -1) {
          this.listCurrentMembers.push({
            ...user,
            userRoleId: 0,
            isNew: true,
            deleted: false
          });
        }
        else { this.listCurrentMembers[index].deleted = false; }
      },
      toSearchList() {
        this.listUsers.forEach((user) => {
          user.searchProp = user.lastName + ' ' + user.firstName + ' - ' + user.postTitle;
          user.userId = user.id;
          //this.searchList.push(user);
        });
        //console.log(this.listUsers);
      },
      getUsersByCompany(companyId) {
        UserService.getListByCompanyId(companyId).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          }
          else {
            this.listUsers = result.data;
            setTimeout(() => this.toSearchList(), 100);
          }
        }).catch(e => {
          console.log(e);
        });
      },
      getRole() {
        RoleService.getRole(this.id).then(response => {
          let result = response.data;
          if (result.success) {
            this.role = result.data;
          }
          else {
            this.$toast.error(result.massage);
          }
        }).catch(e => {
          console.log(e);
        });
      },
      goBack() {
        this.$router.push('/roles/' + this.role.companyId);
      }
    },
    created() {
      this.id = this.$route.params.roleId;

      this.getRole();
      //this.getUsersByCompany();
      this.getCurrentMember();
    }
  };
</script>
